import React, { useContext } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  LineElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import Tab4ContentChartIncomer from "./Tab4ContentChartIncomer/Tab4ContentChartIncomer";
import Tab4ContentChart2 from "./Tab4ContentChart2/Tab4ContentChart2";
import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
import IncomerDay from "../IncomerDay/IncomerDay";

ChartJS.register(
  LineElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const Tab4ContentChart1 = () => {
  const { PrimaryColor } = useContext(AppThemeContext);

  const cardStyle = {
    p: 2,
    borderRadius: 3,
    boxShadow: 3,
    height: "100%"
  };

  // Dummy Data
  const labels = ["1", "2", "3", "4", "5", "6"];

  const currentKWData = {
    labels,
    datasets: [
      {
        label: "Current KW",
        data: [10, 20, 15, 30, 25, 40],
        borderColor: "orange",
        backgroundColor: "orange"
      }
    ]
  };

  const energyData = {
    labels,
    datasets: [
      {
        label: "Energy (KWh)",
        data: [100, 200, 150, 300, 250, 400],
        borderColor: "green",
        backgroundColor: "lightgreen"
      }
    ]
  };

  const peakData = {
    labels,
    datasets: [
      {
        label: "Peak KW",
        data: [5, 10, 8, 15, 12, 18],
        backgroundColor: "skyblue"
      }
    ]
  };

  return (
    <Grid container spacing={1} mt={0}>
      {/* Current KW */}
      <Grid item xs={12} md={4}>
        <Paper sx={cardStyle}>
          {/* <Typography fontWeight="bold"> </Typography> */}
          <Typography
            fontWeight="bold"
            textAlign="center"
            sx={{
              background: PrimaryColor,
              color: "#fff",
              py: 1,
              mb: 1,
              fontSize: "1.6rem",
            }}
          >
           Current kW Vs. Daily kWh Vs. Peak kW  (Incomer)
          </Typography>
          {/* <Line data={currentKWData} /> */}
          <Tab4ContentChartIncomer />
        </Paper>
      </Grid>

      {/* Energy */}
      <Grid item xs={12} md={4}>
        <Paper sx={cardStyle}>
          {/* <Typography fontWeight="bold">
            Live kW Vs. Todays kwh Vs. Peak kW Vs. (Outgoing)
          </Typography> */}
          <Typography
            fontWeight="bold"
            textAlign="center"
            sx={{
              background: PrimaryColor,
              color: "#fff",
              py: 1,
              mb: 1,
              fontSize: "1.6rem",
            }}
          >
            Current kW Vs. Daily kWh Vs. Peak kW (Outgoing)
          </Typography>
          <Tab4ContentChart2 />
        </Paper>
      </Grid>

      {/* Peak */}
      <Grid item xs={12} md={4}>
        <Paper sx={cardStyle}>
          {/* <Typography fontWeight="bold">
            Today's Incomer Peak [KW]
          </Typography> */}

          <Typography
            fontWeight="bold"
            textAlign="center"
            sx={{
              background: PrimaryColor,
              color: "#fff",
              py: 1,
              mb: 1,
              fontSize: "1.6rem",
            }}
          >
          Incomer day (KWH)   
          </Typography>
          <IncomerDay/>
          {/* <Bar data={peakData} /> */}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Tab4ContentChart1;